import React from "react";
import DataTable, { createTheme, IDataTableProps } from "react-data-table-component";
import { Image, Text, View } from "react-native";
import { FONT_SIZE } from "../../styles";
import styled from "@emotion/styled";
import { THEME_COLORS } from "../../../common/themes";

createTheme("refurb", {
  text: {
    primary: "black",
    secondary: "#2aa198",
  },
  background: {
    default: "",
  },
});

const customStyles = {
  rows: {
    style: {
      minHeight: "auto", // override the row height
      height: "auto",
      paddingTop: 10,
      paddingBottom: 10,
      backgroundColor: THEME_COLORS.white,
    },
  },
  table: {
    style: {
      backgroundColor: THEME_COLORS.bgWhite,
    },
  },
  tableWrapper: {
    style: {
      display: "table",
    },
  },
  headCells: {
    style: {
      paddingTop: "8px", // override the cell padding for head cells
      paddingBottom: "8px", // override the cell padding for head cells
      fontWeight: 600,
      fontSize: "15px",
      fontFamily: "roboto",
      backgroundColor: THEME_COLORS.grey2,
      shadowRadius: 5,
      shadowColor: THEME_COLORS.shadow3,
    },
  },
  cells: {
    style: {
      paddingRight: "8px", // override the cell padding for data cells
      fontSize: FONT_SIZE,
      fontFamily: "FuturaPTDemi",
    },
  },
};

interface IDataTableComponentProps extends IDataTableProps<any> {
  onClickSort?: (column, direction) => void;
  headRowStyle?: any;
}

const DataTableComponent = (props: IDataTableComponentProps) => {
  const {
    data,
    columns,
    onClickSort,
    overflowYOffset,
    expandableRows,
    expandableRowsComponent,
    expandableIcon,
    onRowExpandToggled,
    highlightOnHover,
    striped,
    expandableRowDisabled,
    expandableRowsHideExpander,
  } = props;

  let headRowStyle = props.headRowStyle;
  let rdtTableHeadRowStyle = "";
  if (!!headRowStyle) {
    let rdtTableHeadRow = [];
    headRowStyle.backgroundColor ? rdtTableHeadRow.push(`background-color: ${headRowStyle.backgroundColor}`) : null;
    headRowStyle.minHeight ? rdtTableHeadRow.push(`min-height: ${headRowStyle.minHeight}`) : null;

    rdtTableHeadRowStyle = rdtTableHeadRow.join(";");
  }
  const noDataComponent = (
    <View
      style={{
        paddingTop: 100,
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        backgroundColor: THEME_COLORS.bgWhite,
      }}
    >
      <Image source={require("../../../assets/no_data.png")} style={{ width: 700, height: 250 }} />
      <Text style={{ color: THEME_COLORS.primary, fontWeight: "bold", marginVertical: 10 }}>
        No results found, Try reducing some filters to find results.
      </Text>
    </View>
  );

  const StyledDataTable = styled(DataTable)`
    .rdt_Table {
      min-width: 100vw;
    }
    .rdt_TableHeadRow {
      ${rdtTableHeadRowStyle}
    }
  `;

  return (
    <StyledDataTable
      fixedHeader={true}
      theme="refurb"
      overflowY={true}
      overflowYOffset={!!overflowYOffset ? overflowYOffset : "265px"}
      noHeader={true}
      columns={columns}
      style={{ paddingBottom: 0, marginBottom: 0 }}
      sortServer={true}
      onSort={(column, sortDirection) => onClickSort(column, sortDirection)}
      data={data}
      customStyles={customStyles}
      persistTableHead={true}
      striped={striped}
      highlightOnHover={highlightOnHover}
      expandableIcon={expandableIcon}
      expandableRowDisabled={expandableRowDisabled}
      expandableRowsHideExpander={expandableRowsHideExpander}
      noDataComponent={noDataComponent}
      expandableRows={!!expandableRows ? expandableRows : false}
      expandableRowsComponent={expandableRowsComponent}
      onRowExpandToggled={onRowExpandToggled}
    />
  );
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody:nth-child(even) {
    backgroun-color: grey;
  }
  .rdt_TableBody:last-child {
    padding-bottom: 20px;
  }
  .rdt_Table {
    min-width: 100vw;
  }
`;

export default DataTableComponent;
